import { TablePaginationProps } from './types';
import { styleTablePagination } from './style';
import { Pagination } from 'stubben-edge-unified-frontend-react-components';
import clsx from 'clsx';

const TablePagination = (props: TablePaginationProps) => {
  props = {
    ...{
      rowsPerPageOptions: [10, 25, 50, 100],
      labelRowsPerPage: 'items per page',
      showPageNumberButtons: true,
      pageNumberButtonRange: 3,
      alignPagination: 'center'
    },
    ...props
  };

  const { className, onPageChange, onRowsPerPageChange } = props;

  const cls = styleTablePagination(props);

  const handleChangePerPage = (value: string | number) => {
    if (onRowsPerPageChange) {
      onPageChange && onPageChange(1);
      onRowsPerPageChange(Number(value));
    }
  };

  return (
    <div className={clsx(cls.main, className)}>
      <Pagination
        {...props}
        onPageChange={onPageChange}
        onRowsPerPageChange={
          onRowsPerPageChange ? handleChangePerPage : undefined
        }
      />
    </div>
  );
};

export default TablePagination;
